import { useProductFlags } from "src/hooks/recoil/useProductFlags";
import styles from "./index.module.scss";
import useProductInfo, { isDspProductList } from "src/mocks/useProductInfo";
import { useState, useEffect } from "react";
import { productKeyAtom } from "src/atoms";
import { useRecoilState } from "recoil";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const DspList = () => {
  const { isDspProduct } = useProductFlags();
  const { productOptions } = useProductInfo();
  const { t } = useTranslation();
  const [productKey, setProductKey] = useRecoilState(productKeyAtom);
  // DSP 제품 리스트
  const dspProductList = productOptions.filter((item) =>
    isDspProductList.includes(item.value)
  );
  const [selectAppList, setSelectAppList] = useState<string[]>([
    productKey || "",
  ]);
  // console.log(dspProductList);
  const { setValue } = useFormContext();

  // 초기 선택 항목이 있으면 폼 필드에도 설정
  useEffect(() => {
    const initialList = productKey ? [productKey].filter(Boolean) : [];
    if (initialList.length > 0) {
      setValue("requestProducts", initialList);
    }
  }, [productKey, setValue]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, checked } = e.target;
    if (checked) {
      setSelectAppList([...selectAppList, value]);
      setValue("requestProducts", [...selectAppList, value]);
    } else {
      setSelectAppList(selectAppList.filter((item) => item !== value));
      setValue(
        "requestProducts",
        selectAppList.filter((item) => item !== value)
      );
    }
  };

  return (
    <>
      {isDspProduct && (
        <div className={styles.upcContainer}>
          <span className={styles.formItemTitle}>
            {t("cashStatus.chooseSolution")}
          </span>
          <div className={styles.selectedAppTitle}>
            {t("common.selected")}
            <span className={styles.selectedAppCount}>
              {selectAppList.length}
            </span>{" "}
            {t("common.items")}
            {/* 선택된 애플리케이션 표시
          {selectAppList.length > 0 && (
            <div className={styles.selectedApplications}>
              <div className={styles.selectedTitle}>
                {t("admin.upc.site.selectedApp")}:
              </div>
              <div className={styles.selectedList}>
                {dspProductList
                  .filter((item: any) =>
                    selectAppList.includes(item.nxacAppUid)
                  )
                  .map((item: any, index: number) => (
                    <div key={item.nxacAppUid} className={styles.selectedItem}>
                      - {item.applicationName}
                    </div>
                  ))}
              </div>
            </div>
          )} */}
          </div>

          <div className={styles.selectApplication}>
            {dspProductList.length > 0 &&
              dspProductList.map((item: any, index: number) => {
                return (
                  <div key={item.value} className={styles.applicationItem}>
                    <div className={styles.checkboxGroup}>
                      <input
                        type="checkbox"
                        name="requestProducts"
                        id={"requestProducts_" + item.value}
                        value={item.value}
                        checked={selectAppList.indexOf(item.value) !== -1}
                        onChange={handleChange}
                      />
                      <label
                        className={styles.checkbox}
                        htmlFor={"requestProducts_" + item.value}
                      />
                      <span
                        className={`${styles.applicationName}`}
                        title={item.applicationName}
                        onClick={() => {
                          // 체크박스 상태를 토글하는 synthetic event 생성
                          const syntheticEvent = {
                            target: {
                              name: "requestProducts",
                              value: item.value,
                              checked: selectAppList.indexOf(item.value) === -1, // 현재 상태의 반대로 설정
                            },
                          } as React.ChangeEvent<HTMLInputElement>;
                          handleChange(syntheticEvent);
                        }}
                      >
                        {item.label}
                      </span>
                    </div>

                    {/* <button
                      onClick={(e) => openExtDetailModal(e, item.nxacAppUid)}
                      className={styles.moreButton}
                    >
                      {t("common.more")}
                    </button> */}
                  </div>
                );
              })}

            {selectAppList && (
              <input className={styles.hiddenInput} value={selectAppList} />
            )}
          </div>

          {/* <hr className={styles.separator} /> */}
        </div>
      )}
    </>
  );
};

export default DspList;
